import { Box, Button, Fade, Typography } from '@material-ui/core';
import PaymentMethodNotes from '../paymentMethodNotes';

const PaymentMethodHeader = ({
  isFreeTrial,
  classes,
  handleChange,
  isChangeClicked,
  paymentInstrumentLength,
  paymentMethodLabel,
  buttonLabel,
  paymentMethodClasses,
  subscriptionProps,
  isPaymentTemplate,
}) => (
  <Box>
    <Box className={classes.paymentHeaderNode}>
      <Box>
        <Typography
          variant="h2"
          className={paymentMethodClasses.paymentMethodLabelNode}
        >
          {paymentMethodLabel}
        </Typography>
      </Box>
      <Box display={isChangeClicked ? 'none' : 'block'}>
        <Fade
          in={
            !isChangeClicked &&
            paymentInstrumentLength > (isPaymentTemplate ? 0 : 1)
          }
        >
          <Button
            disableRipple
            disableFocusRipple
            size="small"
            data-testid="payment-method-header-change"
            onClick={() => {
              handleChange();
            }}
            style={{
              padding: 0,
              backgroundColor: 'unset',
              justifyContent: 'end',
              minWidth: '50px',
            }}
          >
            <Typography className={classes.changeButtonNode}>
              {buttonLabel}
            </Typography>
          </Button>
        </Fade>
      </Box>
    </Box>
    <Box>
      {isFreeTrial && (
        <PaymentMethodNotes subscriptionProps={subscriptionProps} />
      )}
    </Box>
  </Box>
);

export default PaymentMethodHeader;
